import {evaporationObject} from "./model/EvaporationModels";
import {codeObject, datasourceTypeObject} from "../common/constructorObject";

const {createSlice, createEntityAdapter} = require("@reduxjs/toolkit");

const evaporationSliceAdapter = createEntityAdapter();

export const EVAPORATION_SLICE = 'evaporationConstructor';

const evaporationSlice = createSlice({
  name: EVAPORATION_SLICE,
  initialState: evaporationSliceAdapter.getInitialState({
    ...evaporationObject
  }),
  reducers: {
    selectStation: (state, action) => {
      Object.assign(state.station, action.payload)
    },
    selectStationEntity: (state, action) => {
      Object.assign(state.stationEntity, action.payload)
    },
    selectWaterTempDatasourceType: (state, action) => {
      state.waterTemperatureFilterObject.type = {...datasourceTypeObject}
      Object.assign(state.waterTemperatureFilterObject.type, action.payload)
    },
    selectWaterTempMeteoCode: (state, action) => {
      state.waterTemperatureFilterObject.meteoCode = {...codeObject}
      Object.assign(state.waterTemperatureFilterObject.meteoCode, action.payload)
    },
    selectWindSpeedDatasourceType: (state, action) => {
      state.windSpeedFilterObject.type = {...datasourceTypeObject}
      Object.assign(state.windSpeedFilterObject.type, action.payload)
    },
    selectWindSpeedMeteoCode: (state, action) => {
      state.windSpeedFilterObject.meteoCode = {...codeObject}
      Object.assign(state.windSpeedFilterObject.meteoCode, action.payload)
    },
    setNewEvaporationConstructor: (state, action) => {
      state.id = action.payload.id
      state.station = action.payload.station
      state.stationEntity = action.payload.filters === undefined ?
          action.payload.stationEntity :
            action.payload.filters.stationEntityObject
      state.waterTemperatureFilterObject = action.payload.filters === undefined ?
          action.payload.waterTemperatureFilterObject : action.payload.filters.waterTemperatureFilterObject
      state.windSpeedFilterObject = action.payload.filters === undefined ?
          action.payload.windSpeedFilterObject : action.payload.filters.windSpeedFilterObject
    },
  }
});

export default evaporationSlice.reducer;

export const {
  selectStation,
  selectStationEntity,
  selectWaterTempDatasourceType,
  selectWaterTempMeteoCode,
  selectWindSpeedDatasourceType,
  selectWindSpeedMeteoCode,
  setNewEvaporationConstructor
} = evaporationSlice.actions

